import { render, staticRenderFns } from "./ODCarousel.vue?vue&type=template&id=490d1c91&"
import script from "./ODCarousel.vue?vue&type=script&lang=js&"
export * from "./ODCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490d1c91')) {
      api.createRecord('490d1c91', component.options)
    } else {
      api.reload('490d1c91', component.options)
    }
    module.hot.accept("./ODCarousel.vue?vue&type=template&id=490d1c91&", function () {
      api.rerender('490d1c91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/ODCarousel.vue"
export default component.exports